/**
 * @voltxampere/ui — Pin header 2.54mm (Sprint 45-6, schema-only)
 *
 * Schema-only passthrough — engine'de davranış yok. Single row
 * 2.54 mm pitch pin header — breadboard + Arduino shield + Raspberry
 * Pi GPIO + DIP IC socket standardı.
 *
 * Reference: Generic 2.54 mm (0.1") pin header — Sullins PRPC,
 * Adafruit standart. 2-40 pin row, 3 A current per pin.
 * Breadboard prototyping, Arduino UNO header, Pi GPIO breakout.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const connectorPinHeader = {
    id: "pin-header-2.54",
    nameTr: "Pin Header 2.54mm (single row, schema-only)",
    nameEn: "Pin Header 2.54mm (single row, schema-only)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "J",
    defaultValue: "HDR-2.54",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=connector-pin-header.js.map